import React, { useContext } from "react";

import Select from "Components/GMS/Select";

import { CSContext } from "../contexts/CSContext";
import { EMPTY_PIVOT_ELEMENT } from "../constants/CSConstants";
import { areObjectsIdentical } from "Pages/GMS/ISR/Components/RuleComponents/helper";


const CSCategorySelection = (props: { id: string, categoryId: string, updateTotal: (total: number) => void }) => {
    const { category, categoryList, handleCategoryChange, pivotVersionList, pivotList } = useContext(CSContext)
    const disabled = ["null", null, undefined, "undefined"].includes(props?.categoryId)
        ? false
        : true
        return (
            <div 
                id={`${props.id}-category-container`} 
                className="tw-m-5 tw-w-[25%]"
            >
                <label 
                    id={`${props.id}-category-label`} 
                    className="tw-ml-5 tw-mb-2"
                >
                    Category
                </label>
                <Select
                    id={`${props.id}-category-select`}
                    onChange={(e) => {
                        handleCategoryChange(e, props?.updateTotal);
                    }}
                    value={category as string}
                    options={categoryList}
                    name={"Select Category"}
                    disabled={
                        disabled || (category && pivotVersionList?.length === 0 && pivotList && !areObjectsIdentical(pivotList[0], EMPTY_PIVOT_ELEMENT))
                    }
                    hideLabel={true}
                    isSearchable
                />
            </div>
    );
};

export default CSCategorySelection;
